import React from "react";
import img from "../assets/images/elecauto5.jpg";

const Header = () => {
  return (
    <div
      class="bg-[#302f4f] bg-cover bg-center h-screen mb-[5rem] flex flex-col
   justify-center items-center text-white "
    >
      <img
        src={img}
        class="w-full bg-cover bg-center bg-no-repeat "
        alt="background"
      />
      <div class="absolute container flex flex-col items-start justify-center mx-auto mt-10 md:flex-col md:items-left md:justify-start space-y-8 md:px-12">
        <h1 class="max-w-l leading-none text-5xl text-white  md:mr-5">
          Market & Regulatory Advisory Services
        </h1>
        <p class="text-lg">
          Precise and accurate engineering analysis and design is essential for
          the development and management of any project.
        </p>
        <button class="bg-[#bd6961] text-white px-6 py-3 rounded-full hover:bg-[#7a3432] duration-500">
          FIND OUT MORE
        </button>
      </div>
    </div>
  );
};

export default Header;
